import { APP_NAME } from '../constants';

const APPLICATION = 'x-client-application';
const CONTENT_TYPE = 'Content-Type';

export const HEADERS = {
  [APPLICATION]: APP_NAME,
  [CONTENT_TYPE]: 'application/json',
};
